import React from "react";
import { certificates } from "../constants";

/* ═══════════════════════════════════════════════════════════
   CERTIFICATES — Luxury Credential Grid
   Gold hairline cards · liquid reveals
   ═══════════════════════════════════════════════════════════ */

const Certificates = () => {
  return (
    <div className="lux-container">
      <div className="max-w-3xl mb-20">
        <p className="lux-eyebrow mb-6">Credentials</p>
        <h2 className="lux-heading">
          <span className="reveal-line">
            <span>Certificates</span>
          </span>
        </h2>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {certificates.map((cert, i) => (
          <div key={`cert-${i}`} className="lux-card reveal-fade p-6 flex flex-col">
            <span
              className="font-display text-3xl text-champagne-500/50 mb-4"
              aria-hidden="true"
            >
              ✦
            </span>
            <h3 className="font-grotesk text-sm font-medium text-silver-100 leading-relaxed flex-1">
              {cert.name}
            </h3>
            <p className="text-xs text-silver-500 mt-4 tracking-wide">
              {cert.issuer}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Certificates;